import clsx from 'clsx';
import { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'base' | 'md' | 'lg' | 'xs';
}

function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      type="button"
      className={clsx(
        'rounded-md font-medium transition-colors',
        // Base styles for each variant without colors
        {
          'h-10 text-center text-sm font-nunito font-semibold leading-6':
            variant === 'primary',
          '': variant === 'secondary',
        },
        // Size variations
        {
          'px-2.5 py-1.5 text-sm': size === 'sm',
          'px-4 py-1.75 text-[14px]': size === 'base',
          'px-4 py-2 text-base': size === 'md',
          'px-6 py-3 text-lg': size === 'lg',
          'px-8 py-0.5 text-xs h-auto rounded-lg': size === 'xs',
        },
        // Default colors with disabled state
        {
          'bg-primary hover:bg-primary-hover':
            variant === 'primary' && !className?.includes('bg-') && !disabled,
          'bg-gray-200 text-gray-800 hover:bg-gray-300':
            variant === 'secondary' && !className?.includes('bg-') && !disabled,
          'bg-[#FDFAF8] border border-[#D9D9D9] text-[#434343]':
            variant === 'outline' &&
            !className?.includes('border-') &&
            !disabled,
          'bg-[rgba(0,0,0,0.04)]': disabled,
        },
        // Text color handling for primary variant and disabled state
        {
          'text-[#8C8C8C]': disabled,
          'text-white': variant === 'primary' && !disabled,
        },
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}

export { Button };
